import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'
import { pdfLabelSetRepository } from '@webapp/modules/vendor/data-access/repositories/PDFLabelSetRepository' // eslint-disable-line import/no-internal-modules
import { pdfLabelSetQueryConfig } from '@webapp/modules/vendor/query-configs/pdf-label-set' // eslint-disable-line import/no-internal-modules

export const useMutateDeletePOPDFLabelSet = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, string>({
    mutationFn: (key: string) => pdfLabelSetRepository.delete(key),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: pdfLabelSetQueryConfig.all().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: poPdfLabelEditorQueryConfig.initialSet().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
